function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useLayoutEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { ScoreIdsInput } from "./ReconciliationModal/ScoreIdsInput";
import { CampaignPOInput } from "./ReconciliationModal/CampaignPOInput";
import { BusinessUnitInput } from "./ReconciliationModal/BusinessUnitInput";
import { Summary } from "./ReconciliationModal/Summary";
import { ProjectMinimumInput } from "./ReconciliationModal/ProjectMinimumInput";
import { FinanceNoteInput } from "./ReconciliationModal/FinanceNoteInput";
import { useForm } from "react-hook-form";
import { useDebounce } from "use-debounce";
import flow from "lodash/fp/flow";
import uniq from "lodash/fp/uniq";
import filter from "lodash/fp/filter";
import partition from "lodash/fp/partition";
var filterIds = function(rawAcceptedIds, allIdsByIdentifier, completedByIdentifier) {
    var rejectedById = _object_spread({}, completedByIdentifier);
    var acceptedTotal = 0.0;
    var avgCPI = 0.0;
    var acceptedIdsByCPI = {};
    var _flow = _sliced_to_array(flow(filter(function(id) {
        return id && id !== "" && id !== "\n";
    }), uniq, partition(function(id) {
        var acceptedIdentifier = allIdsByIdentifier[id];
        if (!!acceptedIdentifier) {
            delete rejectedById[id];
            acceptedTotal += parseFloat(acceptedIdentifier.cpi);
            acceptedIdsByCPI[acceptedIdentifier.cpi] = _to_consumable_array(acceptedIdsByCPI[acceptedIdentifier.cpi] || []).concat([
                acceptedIdentifier
            ]);
        }
        return !!acceptedIdentifier;
    }))(rawAcceptedIds || []), 2), acceptedIds = _flow[0], unrecognizedIds = _flow[1];
    avgCPI = acceptedTotal / acceptedIds.length;
    return {
        acceptedIds: acceptedIds,
        avgCPI: avgCPI,
        unrecognizedIds: unrecognizedIds,
        rejectedById: rejectedById,
        acceptedTotal: acceptedTotal,
        acceptedIdsByCPI: acceptedIdsByCPI
    };
};
export var ReconciliationModal = function(param) {
    var currentCPI = param.currentCPI, customerBillingAddresses = param.customerBillingAddresses, customerBillingAddressId = param.customerBillingAddressId, po = param.po, playerScoreIdsByCPI = param.playerScoreIdsByCPI, completedPlayerScoreIds = param.completedPlayerScoreIds, idKey = param.idKey, chargeProjectMinimum = param.chargeProjectMinimum, _param_externalCustomer = param.externalCustomer, externalCustomer = _param_externalCustomer === void 0 ? false : _param_externalCustomer, onSubmit = param.onSubmit;
    var _useForm = useForm(), register = _useForm.register, watch = _useForm.watch, handleSubmit = _useForm.handleSubmit;
    var rawAcceptedIdsString = watch("accepted_ids", "");
    var _useDebounce = _sliced_to_array(useDebounce(rawAcceptedIdsString, completedPlayerScoreIds.length > 10000 ? 500 : 10), 1), acceptedIdsString = _useDebounce[0];
    var idsByIdentifier = React.useMemo(function() {
        return Object.keys(playerScoreIdsByCPI).reduce(function(acc, key) {
            var playerScoreInCPI = playerScoreIdsByCPI[key];
            playerScoreInCPI.forEach(function(playerScore) {
                acc.idsByIdentifier[playerScore.identifier] = _object_spread_props(_object_spread({}, playerScore), {
                    cpi: key
                });
            });
            return acc;
        }, {
            idsByIdentifier: {}
        });
    }, [
        playerScoreIdsByCPI
    ]).idsByIdentifier;
    var _React_useMemo = React.useMemo(function() {
        return completedPlayerScoreIds.reduce(function(acc, id) {
            var cpi = idsByIdentifier[id].cpi;
            acc.completeIdsByCPI[cpi] = _to_consumable_array(acc.completeIdsByCPI[cpi] || []).concat([
                idsByIdentifier[id]
            ]);
            acc.completedById[id] = idsByIdentifier[id];
            return acc;
        }, {
            completeIdsByCPI: {},
            completedById: {}
        });
    }, [
        completedPlayerScoreIds,
        idsByIdentifier
    ]), completedByIdentifier = _React_useMemo.completedById;
    var _React_useMemo1 = React.useMemo(function() {
        return filterIds(acceptedIdsString === "" ? [] : acceptedIdsString.split(/(?:[,| :;(\n)]| )+/), idsByIdentifier, completedByIdentifier);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        acceptedIdsString
    ]), acceptedIds = _React_useMemo1.acceptedIds, unrecognizedIds = _React_useMemo1.unrecognizedIds, rejectedById = _React_useMemo1.rejectedById, acceptedTotal = _React_useMemo1.acceptedTotal, acceptedIdsByCPI = _React_useMemo1.acceptedIdsByCPI, avgCPI = _React_useMemo1.avgCPI;
    var _React_useMemo2 = React.useMemo(function() {
        var rejectedIds = Object.keys(rejectedById);
        var _rejectedIds_reduce = rejectedIds.reduce(function(acc, id) {
            var record = rejectedById[id];
            acc.rejectedByCPI[record.cpi] = _to_consumable_array(acc.rejectedByCPI[record.cpi] || []).concat([
                record
            ]);
            acc.rejectedTotal += parseFloat(record.cpi);
            return acc;
        }, {
            rejectedByCPI: {},
            rejectedTotal: 0.0
        }), rejectedByCPI = _rejectedIds_reduce.rejectedByCPI, rejectedTotal = _rejectedIds_reduce.rejectedTotal;
        return {
            rejectedByCPI: rejectedByCPI,
            rejectedTotal: rejectedTotal,
            rejectedIds: rejectedIds
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        acceptedIdsString
    ]), rejectedByCPI = _React_useMemo2.rejectedByCPI, rejectedTotal = _React_useMemo2.rejectedTotal, rejectedIds = _React_useMemo2.rejectedIds;
    // It isn't worth it doing this in React right now
    useLayoutEffect(function() {
        if (!externalCustomer) {
            if (acceptedTotal < window.Constants.ADHOC_PROJECT_MINIMUM) {
                window.$(".project-minimum").slideDown();
            } else {
                window.$(".project-minimum").slideUp();
            }
        }
    }, [
        acceptedTotal,
        externalCustomer
    ]);
    var innerOnSubmit = function(data) {
        onSubmit(_object_spread_props(_object_spread({}, data), {
            accepted_ids: acceptedIds.join(",")
        }));
    };
    var buildPercentageString = function(value, total) {
        var percent = total === 0 ? 0 : (value * 100 / total).toFixed(2);
        return " (".concat(percent, "%)");
    };
    var totalPc = "";
    var acceptedPc = buildPercentageString(acceptedIds.length, completedPlayerScoreIds.length);
    var rejectedPc = buildPercentageString(rejectedIds.length, completedPlayerScoreIds.length);
    var unrecognizedPc = buildPercentageString(unrecognizedIds.length, completedPlayerScoreIds.length);
    return /*#__PURE__*/ React.createElement("form", {
        id: "campaign-reconciliation-form",
        onSubmit: handleSubmit(innerOnSubmit)
    }, /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
        sm: 4
    }, /*#__PURE__*/ React.createElement(ScoreIdsInput, {
        title: "Recorded IDs",
        metricsClassName: "recorded-metrics",
        values: completedPlayerScoreIds,
        testidPrefix: "recorded-ids",
        percent: totalPc
    })), /*#__PURE__*/ React.createElement(Col, {
        sm: 4
    }, /*#__PURE__*/ React.createElement(ScoreIdsInput, _object_spread({
        title: "Accepted IDs",
        metricsClassName: "accepted-metrics",
        placeholder: "Enter accepted IDs",
        testidPrefix: "accepted-ids",
        values: acceptedIds,
        percent: acceptedPc
    }, register("accepted_ids"))), idKey && /*#__PURE__*/ React.createElement("div", null, "For this campaign, the IDs are associated with the variable ", /*#__PURE__*/ React.createElement("b", null, idKey), " from your entry URL")), /*#__PURE__*/ React.createElement(Col, {
        sm: 4
    }, /*#__PURE__*/ React.createElement(CampaignPOInput, _object_spread({
        po: po
    }, register("po"))), ((customerBillingAddresses === null || customerBillingAddresses === void 0 ? void 0 : customerBillingAddresses.length) > 1 || customerBillingAddressId) && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement(BusinessUnitInput, _object_spread({
        businessAddresses: customerBillingAddresses,
        selectedBusinessId: customerBillingAddressId
    }, register("customer_billing_address_id"))), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("br", null)), /*#__PURE__*/ React.createElement(FinanceNoteInput, register("finance_note")))), /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Col, {
        sm: 4
    }, /*#__PURE__*/ React.createElement(ScoreIdsInput, {
        title: "Rejected IDs (verify with client)",
        metricsClassName: "rejected-metrics",
        testidPrefix: "rejected-ids",
        values: rejectedIds,
        percent: rejectedPc
    })), /*#__PURE__*/ React.createElement(Col, {
        sm: 4
    }, /*#__PURE__*/ React.createElement(ScoreIdsInput, {
        title: "Unrecognized IDs",
        metricsClassName: "incorrectly-accepted-metrics",
        testidPrefix: "unrecognized-ids",
        values: unrecognizedIds,
        percent: unrecognizedPc
    })), /*#__PURE__*/ React.createElement(Col, {
        sm: 4,
        className: "align-center spacing-top-3x"
    }, /*#__PURE__*/ React.createElement(Summary, {
        cpi: currentCPI,
        avgCPI: avgCPI,
        acceptedTotal: acceptedTotal,
        rejectedTotal: rejectedTotal,
        acceptedIdsByCPI: acceptedIdsByCPI,
        rejectedIdsByCPI: rejectedByCPI
    }), !externalCustomer && /*#__PURE__*/ React.createElement(ProjectMinimumInput, _object_spread({
        checked: chargeProjectMinimum
    }, register("charge_project_minimum"))), /*#__PURE__*/ React.createElement("button", {
        type: "submit",
        className: "btn complete-reconciliation"
    }, "Complete reconciliation"))));
};
